// Analytics Event Names
// {object}_{action}_{outcome}
export const ANALYTICS_EVENTS = {
  // Load events (fired on component mount)
  LOAN_SELECTOR_LOAD: 'loan_selector_load',
  SIGNUP_LOAD: 'signup_load',
  LOGIN_LOAD: 'login_load',
  DISCLOSURES_LOAD: 'disclosures_load',
  PERSONAL_INFO_LOAD: 'personal_info_load',
  SECURE_INFO_LOAD: 'secure_info_load',
  PREQUAL_LANDING_LOAD: 'prequal_landing_load',
  PREQUAL_BANK_DETAILS_LOAD: 'prequal_bank_details_load',

  // Submit events (fired on form submission attempt)
  LOAN_SELECTOR_SUBMIT: 'loan_selector_submit',
  SIGNUP_SUBMIT: 'signup_submit',
  LOGIN_SUBMIT: 'login_submit',
  DISCLOSURES_SUBMIT: 'disclosures_submit',
  PERSONAL_INFO_SUBMIT: 'personal_info_submit',
  SECURE_INFO_SUBMIT: 'secure_info_submit',
  PREQUAL_LANDING_SUBMIT: 'prequal_landing_submit',
  PREQUAL_BANK_DETAILS_SUBMIT: 'prequal_bank_details_submit',

  // Success events (fired on successful API response)
  LOAN_SELECTOR_SUCCESS: 'loan_selector_success',
  SIGNUP_SUCCESS: 'signup_success',
  LOGIN_SUCCESS: 'login_success',
  DISCLOSURES_SUCCESS: 'disclosures_success',
  PERSONAL_INFO_SUCCESS: 'personal_info_success',
  SECURE_INFO_SUCCESS: 'secure_info_success',
  PREQUAL_LANDING_SUCCESS: 'prequal_landing_success',
  PREQUAL_BANK_DETAILS_SUCCESS: 'prequal_bank_details_success',

  // Error events (fired on API errors)
  LOAN_SELECTOR_ERROR: 'loan_selector_error',
  SIGNUP_ERROR: 'signup_error',
  LOGIN_ERROR: 'login_error',
  DISCLOSURES_ERROR: 'disclosures_error',
  PERSONAL_INFO_ERROR: 'personal_info_error',
  SECURE_INFO_ERROR: 'secure_info_error',
  PREQUAL_LANDING_ERROR: 'prequal_landing_error',
  PREQUAL_BANK_DETAILS_ERROR: 'prequal_bank_details_error',

  // Validation error events (fired on frontend validation failure)
  LOAN_SELECTOR_VALIDATION_ERROR: 'loan_selector_validation_error',
  SIGNUP_VALIDATION_ERROR: 'signup_validation_error',
  LOGIN_VALIDATION_ERROR: 'login_validation_error',
  DISCLOSURES_VALIDATION_ERROR: 'disclosures_validation_error',
  PERSONAL_INFO_VALIDATION_ERROR: 'personal_info_validation_error',
  SECURE_INFO_VALIDATION_ERROR: 'secure_info_validation_error',
  PREQUAL_LANDING_VALIDATION_ERROR: 'prequal_landing_validation_error',
  PREQUAL_BANK_DETAILS_VALIDATION_ERROR: 'prequal_bank_details_validation_error',

  // Prequal offer events
  OFFER_VIEW: 'offer_view',
  
  // A/B Testing
  AB_TEST_ASSIGNMENT: 'experiment_impression',

  // Test Event
  TEST_EVENT: 'test_event',
};